import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// import NotificationError from "../../../components/UI/NotificationError/NotificationError";
import ProfileDataItem from "./ProfileDataItem/ProfileDataItem";

import "./ProfileData.sass";

function ProfileData({ userData, userDataError }) {
  const [entity] = useState([
    {
      field: "age_status",
      title: "Age Status",
      type: "select",
      data: userData && userData.age_status,
      options: [
        { value: "over_18", label: "18+" },
        { value: "under_18", label: "Under 18" },
      ],
      isEditable: true,
    },
    {
      field: "gender",
      title: "Gender",
      type: "select",
      data: userData && userData.gender,
      options: [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "not_applicable", label: "N/A" },
      ],
      isEditable: true,
    },
    {
      field: "fullName",
      title: "Full name",
      type: "text",
      data: userData && `${userData.first_name} ${userData.last_name}`,
      isEditable: true,
    },
    {
      field: "email",
      title: "Email",
      type: "text",
      data: userData && userData.email,
      isEditable: true,
    },
    {
      field: "phone",
      title: "Primary phone",
      type: "text",
      data: userData && userData.phone,
      isEditable: true,
    },
    {
      field: "address",
      title: "Address",
      type: "text",
      data: userData && userData.address,
      isEditable: true,
    },
  ]);

  if (userDataError !== "") {
    throw new Error(userDataError);
  }

  return (
    <>
      {userData && (
        <article className="profile-data">
          {userData && userData.cid && (
            <>
              <section className="profile-data-cell profile-data-cell--cid">
                <p className="profile-data-cell__title">Customer ID</p>
                <div className="profile-data-cell-value">
                  <p className="profile-data-cell-value__text">
                    {userData.cid}
                  </p>
                </div>
              </section>
              <section className="profile-data-cell profile-data-cell--profile-type">
                <p className="profile-data-cell__title">Profile Type</p>
                <div className="profile-data-cell-value">
                  <p className="profile-data-cell-value__text">
                    {userData && userData?.profile_type
                      ? userData?.profile_type?.charAt(0).toUpperCase() +
                        userData?.profile_type?.slice(1)
                      : "Basic"}
                  </p>
                </div>
              </section>
            </>
          )}
          {entity.map((item, index) => (
            <ProfileDataItem key={index} fieldItem={item} />
          ))}
        </article>
      )}
    </>
  );
}

ProfileData.propTypes = {
  userData: PropTypes.objectOf(PropTypes.string),
  userDataError: PropTypes.string,
};
ProfileData.defaultProps = {
  userData: null,
  userDataError: "",
};

const mapStateToProps = (state) => ({
  userData: state.userDataStore.userData,
  dataIsLoading: state.userDataStore.userDataIsLoading,
  userDataError: state.userDataStore.userDataError,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileData);
